export default function InstallValidation(NetteAjax) {
  // support $this->redirect()
  return NetteAjax.ext('redirect', {
    success: function (payload) {
      if (payload.redirect) {
        window.location.href = payload.redirect
        return false
      }
    },
  })
}
